import React from 'react'
import { BsInfoCircleFill } from 'react-icons/bs'
import PageHeaderComponent from '../../components/pageHeader'
import './styles.scss'

import { RiFlutterFill } from 'react-icons/ri'
import { SiDart, SiPostgresql, SiMysql, SiFirebase, SiMongodb, SiFastapi, SiLeaflet, SiFlask, SiClickhouse, SiCplusplus } from 'react-icons/si'
import { FaJava, FaGithub, FaNodeJs, FaJs, FaPython, FaReact, FaRust, FaLinux, } from 'react-icons/fa'



const databaseIcons = [
    {
        name: "PostgreSQL",
        icon: SiPostgresql
    },
    {
        name: "MySQL",
        icon: SiMysql
    },
    {
        name: "Firebase",
        icon: SiFirebase

    },
    {
        name: "MongoDB",
        icon: SiMongodb
    },
    {
        name: "Clickhouse",
        icon: SiClickhouse
    }
]

const techIcons = [
    {
        name: "Flutter",
        icon: RiFlutterFill
    },
    {
        name: "FastAPI",
        icon: SiFastapi
    },
    {
        name: "Leaflet",
        icon: SiLeaflet
    },
    {
        name: "Flask",
        icon: SiFlask
    },
    {
        name: "GitHub",
        icon: FaGithub
    },
    {
        name: "NodeJS",
        icon: FaNodeJs
    },
    {
        name: "React",
        icon: FaReact
    },
    {
        name: "Linux",
        icon: FaLinux
    }
]

const languageIcons = [
    {
        name: "JavaScript",
        icon: FaJs
    },
    {
        name: "Python",
        icon: FaPython
    },
    {
        name: "Dart",
        icon: SiDart
    },
    {
        name: "C++",
        icon: SiCplusplus
    },
    {
        name: "Rust",
        icon: FaRust
    },
    {
        name: "Java",
        icon: FaJava
    }
]

const allIcons = [...languageIcons, ...techIcons, ...databaseIcons]

const summary = "I am Pranav, a Software Engineer from India! I am currently working on a project at the Indian Space Research Organization. I have coded in over 11 languages and have used different techstacks over my computer science degree from Shiv Nadar University. I love to work on new stuff and currently I am exploring the Web3 domain and constantly improving my problem solving skills. And yes, I am actively looking for challenging and rewarding roles from coming June."

const personalInfo = [
    {
        label: 'Name',
        value: 'Pranav Soni'
    },
    {
        label: 'Age',
        value: '23'
    },
    {
        label: 'Email',
        value: 'pranav.bhawan@gmail.com'
    },
    {
        label: 'LinkedIn',
        value: 'https://www.linkedin.com/in/ps428/'
    },
    {
        label: 'GitHub',
        value: 'https://www.github.com/ps428'
    }
]



const About = () => {
    return (
        <section id="about" className='about'>
            <PageHeaderComponent
                headerText="About Me"
                icon={<BsInfoCircleFill size={40} />}
            />
            <div className='about__content'>
                <div className='about__content__personalWrapper'>
                    <div className='about__content__personalWrapper__box'>
                        <h3>Who am I?</h3>
                        <p>{summary}</p>

                    </div>
                    <div className='about__content__personalWrapper__box'>
                        <h3 className='personalInformationHeaderText'>Personal information</h3>
                        <ul>
                            {
                                personalInfo.map((info, index) => {
                                    return (
                                        <li key={index}>
                                            <span className='title'> {info.label}</span>
                                            <span className='value'>{info.value}</span>
                                        </li>
                                    )
                                }
                                )
                            }
                        </ul>
                    </div>
                </div>
                <div className='about__content__skillsWrapper'>
                    <img alt='githubStats' src='https://github-profile-summary-cards.vercel.app/api/cards/profile-details?username=ps428&theme=gotham'></img>
                    <div className='about__content__skillsWrapper__skillsRow'>
                        <img alt='gitTopLangsRepo' src='http://github-profile-summary-cards.vercel.app/api/cards/repos-per-language?username=ps428&theme=gotham'></img>
                        <img alt='gitTopLangsCommits' src='http://github-profile-summary-cards.vercel.app/api/cards/most-commit-language?username=ps428&theme=gotham'></img>
                    </div>
                </div>

            </div>
            <div className="about__iconsWrapper">
                <div className="about__iconsWrapper__iconRow">
                    {
                        allIcons.map((icon, index) => {
                            return (
                                <div key={index} className="about__iconsWrapper__iconRow_icon">
                                    <icon.icon size={40} />
                                </div>
                            )
                        })
                    }

                </div>
            </div>
        </section>

    )
}

export default About;